import { useTranslation } from 'react-i18next';

import { getEvaluationDepartmentAdminFileDownloadUrl } from '@/module/Evaluation/model/EvaluationApi';
import { useEvaluationUploadDepartmentAdminSignedFile } from '@/module/Evaluation/model/EvaluationQuery';

import { Id, PersistentFile, useAppNotification } from '@feature/utils';

import { EvaluationAuthorFile } from './EvaluationAuthorFile';

interface EvaluationDepartmentAdminSignedFileProps {
  userId: Id;
  evaluationId: Id;
  file: PersistentFile | null;
  disabled: boolean;
}

export function EvaluationDepartmentAdminSignedFile({
  evaluationId,
  userId,
  file,
  disabled,
}: EvaluationDepartmentAdminSignedFileProps) {
  const { mutate, isPending } = useEvaluationUploadDepartmentAdminSignedFile(evaluationId, userId);
  const notification = useAppNotification();
  const { t } = useTranslation();

  const onUpload = (newFile: File) => {
    mutate(newFile, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <EvaluationAuthorFile
      onUpload={onUpload}
      file={file}
      disabled={disabled}
      onDownload={() => window.open(getEvaluationDepartmentAdminFileDownloadUrl(evaluationId, userId))}
      isSubmitting={isPending}
      label={t('evaluation.files.departmentAdminSigned.label')}
      description={t('evaluation.files.departmentAdminSigned.description')}
      accept="application/pdf"
    />
  );
}
